angular.module('aprima-legacy-common').factory('DateUtilities',
    ['_', 'moment', 'LanguageFactory',
        function (_, moment, LanguageFactory) {
            'use strict';

            var words = {
                years: {'en_us': 'Years', 'es_mx': 'Años'},
                months: {'en_us': 'Months', 'es_mx': 'Meses'},
                days: {'en_us': 'Days', 'es_mx': 'Días'},
                weeks: {'en_us': 'Weeks', 'es_mx': 'Semanas'},
                deceased: {'en_us': 'deceased at', 'es_mx': 'fallecido en'}
            };
            var lang = LanguageFactory.getLang();

            return {
                getPersonAge: _getPersonAge,
                displayAge: _displayAge,
                getDurationString: getDurationString,
                getPersonAgeAbbr: _getPersonAgeAbbr
            };


            function _getPersonAgeAbbr(birthDate, deathDate, unit) {
                if(!moment(birthDate, 'MM/DD/YYYY').isValid()) {
                    birthDate = moment(birthDate).format('L');
                }
                var ageInfo = _getPersonAge(birthDate, deathDate, unit);
                var age = ageInfo.age + '' + ageInfo.units.charAt(0).toLowerCase();
                return age;
            }
            //  we need to assume the dates from the server are in mm/dd/yyy format
            //  but we can use momentjs to format based on the language selection

            function _getPersonAge(birthDate, deathDate, unit) {
                var _units = 'Years';
                var _age = 0;
                var _deceased = false;
                var end;
                var years, months, days, weeks;
                var langCode = lang.code.toLowerCase();
                var birthDateMoment = birthDate;

                moment.locale(langCode);

                if (!moment(birthDate + '', 'MM/DD/YYYY').isValid()) {
                    return {
                        birthdate: '', age: 0, units: words.years[langCode]
                    };
                }
                else {
                    birthDateMoment = moment(birthDate, 'MM/DD/YYYY');
                }

                var tempDeathDate = moment(deathDate + '', 'MM/DD/YYYY');
                if (tempDeathDate.isValid()) {
                    end = tempDeathDate;
                    _deceased = true;
                }
                else {
                    end = moment();
                }

                years = end.diff(birthDateMoment, 'years');
                months = end.diff(birthDateMoment, 'months');
                days = end.diff(birthDateMoment, 'days');
                weeks = end.diff(birthDateMoment, 'weeks');

                if ((!unit && days < 14) || unit === 'days') {
                    _age = days;
                    _units = words.days[langCode] || 'Days';
                }
                else if ((!unit && months < 2) || unit === 'weeks') {
                    _age = weeks;
                    _units = words.weeks[langCode] || 'Weeks';
                }
                else if ((!unit && years < 2) || unit === 'months') {
                    _age = months;
                    _units = words.months[langCode] || 'Months';
                }
                else {
                    _age = years;
                    _units = words.years[langCode] || 'Years';
                }

                return {
                    birthdate: moment(birthDate, 'MM/DD/YYYY').format('L'),
                    deathdate: moment(deathDate, 'MM/DD/YYYY').format('L'),
                    age: _age,
                    units: _units,
                    deceased: _deceased
                };
            }

            function _displayAge (person, options) {
                var ageString;
                var outputString;
                var langCode = lang.code.toLowerCase();

                if (!person || person.birthdate === '') {
                    return '';
                }

                ageString = person.age + ' ' + person.units;

                if (person.deceased) {
                    ageString = words.deceased[langCode] + ' ' + ageString;
                }

                if (options && options.display === 'age') {
                    return ageString;
                }

                if (options && options.display === 'birthdate') {
                    return person.birthdate;
                }
                outputString = person.birthdate + ' (' + ageString + ')';
                return outputString;
            }

            function getDurationString(refDate) {
                var diff = Date.parse(refDate) - new Date();
                var msg = moment.duration(diff).humanize();
                if(diff < 0)
                    return msg + ' ago';
                else
                    return 'in ' + msg;
            }
        }]);
